//
import { RTableHeaders } from '@/components/reusable_components/next'

//
export default RTableHeaders
  .from([
    {
      text: '#',
      value: 'id',
      width: '8%',
    },
    {
      text: 'numero',
      value: 'number',
      width: '8%',
    },
    {
      text: 'Cliente',
      value: 'sl_customer_business_name',
    },
    {
      text: 'Fecha de emisión',
      value: 'emission_date',
      align: 'right',
      format: 'date',
    },
    {
      text: 'Total',
      value: 'total',
      align: 'right',
      format: 'currency',
    },
  ])

  /**
   * SlSaleInvoiceHeaders to CustomerDetail
   */
  .set('customer_detail', [
    {
      text: 'sucursal',
      value: 'sl_customer_branch_offices_address',
    },
    {
      text: 'numero',
      value: 'number',
    },
    {
      text: 'tipo',
      value: 'documentType',
    },
    {
      text: 'total',
      value: 'total',
      align: 'right',
      format: 'currency',
    },
    {
      text: 'emisión',
      value: 'emission_date',
      align: 'right',
      format: 'date',
    },
    {
      text: 'vencimiento',
      value: 'account_receivable_pay_date',
      align: 'right',
      format: 'date',
    },
    {
      text: 'estado documento',
      value: 'g_state_name',
      align: 'center',
      component: {
        type: 'chip-label',
        props: {
          palette: {
            'no_pagada': 'red lighten-3',
            'pagada': 'success lighten-3',
            'pendiente': 'accent lighten-3',
          },
          small: true,
        },
      },
    },
    {
      text: 'pago',
      value: 'account_receivable_real_pay_date',
      align: 'right',
      format: 'date',
    },
  ])
